import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/lib/utils";

interface VariantDialogShellProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  children: React.ReactNode;
  contentClassName?: string;
}

export function VariantDialogShell({
  open,
  onOpenChange,
  title,
  description,
  children,
  contentClassName,
}: VariantDialogShellProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          "flex w-[calc(100vw-1rem)] max-h-[90dvh] flex-col gap-0 overflow-hidden p-0 sm:max-w-[800px]",
          contentClassName,
        )}
      >
        <DialogHeader className="shrink-0 space-y-1.5 px-4 pb-3 pt-4 text-left sm:px-6 sm:pb-4 sm:pt-6">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-4 pb-4 sm:px-6 sm:pb-6">
          {children}
        </div>
      </DialogContent>
    </Dialog>
  );
}
